import React from 'react';

export const SvgVerticalAlignBottom = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 13h1.79a.5.5 0 01.36.85l-2.79 2.79c-.2.2-.51.2-.71 0l-2.79-2.79c-.32-.31-.1-.85.35-.85H11V4c0-.55.45-1 1-1s1 .45 1 1v9zm-8 8c-.55 0-1-.45-1-1s.45-1 1-1h14c.55 0 1 .45 1 1s-.45 1-1 1H5z"
      fill="currentColor"
    />
  </svg>
);
